import { createAction } from '@reduxjs/toolkit';
import { storeName } from '../config';
import { ProfileRefreshTokensResponse } from '../interfaces';

export const profileSet = createAction<ProfileRefreshTokensResponse>(
  `${storeName}/set`,
);
